let LocalStorage = {
    set(key, data) {
        return window.localStorage.setItem(key, data);
    },
    get(key) {
        return window.localStorage.getItem(key);
    },
    setJson(key, data) {
        return window.localStorage.setItem(key, JSON.stringify(data));
    },
    getJson(key) {
        let value = window.localStorage.getItem(key);
        if (value != null) {
            return JSON.parse(value);
        } else {
            return null;
        }
    },
    remove(key) {
        return window.localStorage.removeItem(key);
    }
};

export default LocalStorage